import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

/**
 * @typedef {object} MuiBackdropProps
 * @property {boolean} open
 */

/**
 * @param {MuiBackdropProps} props
 */
const MuiBackdrop = props => {
  const { open } = props;

  return (
    <Backdrop className='loader' open={open} data-testid='loader'>
      <div>
        <div className='spinner-background' />
        <CircularProgress className='spinner' size={40} thickness={6} />
      </div>
    </Backdrop>
  );
};

export default MuiBackdrop;
